import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { selectSchedulingFlowsEnabled } from '../../../flow/selectors/FlowSelectors';
import { contentCountsRequest } from '../../actions/spaces/ContentCountsActions';
import { selectContentCounts, selectContentCountsUpToDate } from '../../selectors/ContentCountsSelector';
import { SessionServerSelectors, SessionSiteSelectors } from '../../selectors/SessionInfoSelectors';
import { selectSpaceInfo } from '../../selectors/SpaceInfoSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { currentUserIsAdmin } from '../../utils/MixedContentHelpers';
import { TasksSpace, TasksSpaceDispatchProps, TasksSpaceStateProps } from './TasksSpace';

const mapStateToProps: MapStateToProps<TasksSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
  contentCountsSiteTasks: selectContentCounts<'sitetasks'>(state, 'sitetasks'),
  contentCountsServerTasks: selectContentCounts<'servertasks'>(state, 'servertasks'),
  contentCountsUpToDate: selectContentCountsUpToDate(state),
  isDataAlertsEnabled: SessionSiteSelectors.isDataAlertsEnabled(state),
  isFlowOnSiteEnabled: SessionSiteSelectors.isFlowOnSiteEnabled(state),
  isFlowOnServerEnabled: SessionServerSelectors.isFlowOnServerEnabled(state),
  schedulingFlowsEnabled: selectSchedulingFlowsEnabled(state),
  isUserAdmin: currentUserIsAdmin(state)
});

const mapDispatchToProps: MapDispatchToProps<TasksSpaceDispatchProps> =
  (dispatch) => bindActionCreators({
    fetchUpdatedContentCounts: contentCountsRequest
  },
  dispatch);

export const ConnectedTasksSpace = connect(mapStateToProps, mapDispatchToProps)(TasksSpace);
